import PricingMenuItem, { PricingMenuItemProps } from './PricingMenuItem';

export type { PricingMenuItemProps };
export default PricingMenuItem;
